module.exports = __webpack_public_path__ + "static/media/us_staff3.3cbab189.jpg";